import * as React from "react";
import { Dropdown, Option, Field } from "@fluentui/react-components";
import { GlpiCategory } from "../types/glpi";

interface Props {
  categories: GlpiCategory[];
  loading: boolean;
  value: number | null;
  onChange: (id: number | null) => void;
  disabled?: boolean;
  required?: boolean;
  error?: string;
}

export function CategoryDropdown({
  categories,
  loading,
  value,
  onChange,
  disabled,
  required,
  error,
}: Props): React.ReactElement {
  const valueText = React.useMemo(() => {
    const c = categories.find((x) => x.id === value);
    return c ? c.completename || c.name : "";
  }, [categories, value]);

  const placeholder = disabled
    ? "Choisir d'abord une entité"
    : loading
      ? "Chargement…"
      : required
        ? "Choisir une catégorie"
        : "Catégorie (optionnelle)";

  return (
    <Field
      label="Catégorie"
      required={required}
      validationState={error ? "error" : "none"}
      validationMessage={error}
    >
      <Dropdown
        placeholder={placeholder}
        value={valueText}
        selectedOptions={value !== null ? [String(value)] : []}
        onOptionSelect={(_, data) => {
          const v = data.optionValue ? Number(data.optionValue) : null;
          onChange(v);
        }}
        disabled={disabled || loading}
      >
        {!required && (
          <Option value="" text="(aucune)">
            (aucune)
          </Option>
        )}
        {loading && (
          <Option value="__loading" text="Chargement..." disabled>
            Chargement&hellip;
          </Option>
        )}
        {categories.map((c) => (
          <Option key={c.id} value={String(c.id)} text={c.completename || c.name}>
            {c.completename || c.name}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}
